import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * DO NOT EDIT THIS FILE DIRECTLY.
 *
 * This file is automatically generated by running yarn icons:generate.
 */

import * as React from 'react';

function IconEye16(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.696c-1.637 0-3.327-.864-4.687-2.696C4.673 6.168 6.363 5.304 8 5.304c1.637 0 3.327.864 4.687 2.696-1.36 1.832-3.05 2.696-4.687 2.696zm5.713-2.98C12.178 5.483 10.118 4.305 8 4.305S3.822 5.482 2.287 7.717a.5.5 0 000 .566C3.822 10.518 5.882 11.696 8 11.696s4.178-1.178 5.713-3.413a.5.5 0 000-.566zM8 10a2 2 0 100-4 2 2 0 000 4z",
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(IconEye16);
var MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;